import { useEffect, useRef, useState } from 'react';
import api from '../axios_Interceptor/api';
import url from '../server';

export function useNicknameCheck(nickname: string, originalNickname: string) {
  const [checked, setChecked] = useState('');
  const [checking, setChecking] = useState(false);
  const [message, setMessage] = useState('');
  const request = useRef(0);
  const candidate = nickname.trim();
  const valid = !!candidate && Array.from(candidate).length <= 10;
  const available = valid && (candidate === originalNickname.trim() || candidate === checked);

  useEffect(() => {
    request.current += 1;
    setChecked(''); setMessage(''); setChecking(false);
    return () => { request.current += 1; };
  }, [nickname, originalNickname]);

  const check = async () => {
    if (!valid || checking) return;
    const current = ++request.current;
    setChecking(true); setChecked(''); setMessage('');
    try {
      if (candidate !== originalNickname.trim()) {
        const { data } = await api.get(url.Communication_url.nick_dup_check, { params: { nickname: candidate } });
        if (data !== '사용가능') throw new Error('unavailable');
      }
      if (request.current !== current) return;
      setChecked(candidate); setMessage('사용 가능한 닉네임입니다.');
    } catch (error: any) {
      if (request.current !== current) return;
      setMessage(error?.response?.data?.message === '중복' || error?.message === 'unavailable'
        ? '이미 사용 중인 닉네임입니다.' : '중복확인에 실패했습니다. 다시 시도해주세요.');
    } finally { if (request.current === current) setChecking(false); }
  };

  return { available, checking, check, valid, message };
}
